<template lang="pug">
  div(class="trash-can-info block--inner")
    div
      div(class="trash-can__number" :style="{'background-color': canStatus.color}")
        span no.{{can.canId}}
      div(class="trash-can__amount")
        span {{can.trash.volume + can.recycling.volume}} L
      div(class="trash-can__amount")
        span {{can.trash.volume}} L
      div(class="trash-can__amount")
        span {{can.recycling.volume}} L
    div(class="trash-can__btn")
      div(class="trash-can__address")
        span {{can.location.section}}
      div
        div(class="btn__email btn")
          img(:class="{'hide':canStatus.status!=='normal'}" :src="`${require('@/assets/icon/list_mail_normal.svg')}`")
        div(class="btn__location btn ")
          img(:src="`${require('@/assets/icon/list_location_normal.svg')}`")
      div(class="btn__more btn")
        img(:src="`${require('@/assets/icon/list_arrow.svg')}`")
</template>

<script>
import { getCanStatus } from '@/utils/dataHandler.js'
export default {
  name: 'TrashCanInfo',
  props: {
    can: Object
  },

  data () {
    return {
      getCanStatus
    }
  },
  computed: {
    canStatus () {
      return this.getCanStatus(this.can)
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.trash-can-info {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  > div:nth-child(1) {
    display: grid;
    grid-template-columns: 1fr repeat(2, 1.5fr) 0.5fr;
    grid-template-rows: 1fr;
    align-items: center;
  }
  > div:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-template-rows: 1fr;
    align-items: center;
    justify-content: space-between;
    > div {
      justify-self: right;
      align-items: center;
    }
    > div:nth-child(2) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr;
      column-gap: 10px;
      > div {
        display: flex;
        align-items: center;
      }
    }
  }

  .trash-can {
    &__number {
      font-size: 12px;
      background-color: map-get($colors, dark-red);
      color: white;
      padding: 3px 12px;
      border-radius: 15px;
      height: fit-content;
      width: fit-content;
    }
    &__percentage {
      font-size: 20px;
      color: map-get($colors, dark-red);
    }
    &__owner {
      font-size: 14px;
    }
    &__address {
      font-size: 14px;
    }
    &__amount {
      font-size: 14px;
    }
  }

  .decoration {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: map-get($colors, dark-red);
    margin-right: 8px;
  }
  .hide {
    opacity: 0;
  }
}
</style>
